/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmHourScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setStorageMinerPeriodicReward(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/storage/miner/periodic/reward',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setStorageMinerPeriodicReward1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/storage/miner/periodic/reward',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateSignatureMethod(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/signature/method/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateSignatureMethod1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/signature/method/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProxyContractByAddresses({
        addresses,
    }: {
        addresses: Array<string>,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/proxy/contract/update/by/addresses',
            query: {
                'addresses': addresses,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProxyContractByAddresses1({
        addresses,
    }: {
        addresses: Array<string>,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/proxy/contract/update/by/addresses',
            query: {
                'addresses': addresses,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProxyContractInfo(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/proxy/contract/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateProxyContractInfo1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/proxy/contract/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public detectProxyContractsForAllTokens(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/proxy/contract/detect/all/token/contract',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public detectProxyContractsForAllTokens1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/proxy/contract/detect/all/token/contract',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateDefiProject(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/defi/project/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateDefiProject1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/defi/project/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCoinPrice(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/coin/price/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateCoinPrice1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/coin/price/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBurnProjectionByDateRange({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/burn/projection/update/by/date-range',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBurnProjectionByDateRange1({
        startDate,
        endDate,
    }: {
        startDate: string,
        endDate: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/burn/projection/update/by/date-range',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBurnProjection(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/burn/projection/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBurnProjection1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/burn/projection/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBurnHistory(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/hour/burn/history/update',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public updateBurnHistory1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/hour/burn/history/update',
        });
    }

}
